import React from 'react';
import './styles.css';

export const PulsingGlow = ({ children, className = '' }) => {
  return (
    <span className={`pulsing-glow ${className}`}>
      {children}
    </span>
  );
};

export const ShimmeringLine = () => {
  return (
    <div className="shimmering-line-container">
      <div className="shimmering-line"></div>
    </div>
  );
};

export const ParticleDrift = () => {
  return (
    <div className="particle-drift-container">
      {[...Array(12)].map((_, i) => (
        <div
          key={i}
          className="particle"
          style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 30}s`,
            animationDuration: `${20 + Math.random() * 20}s`
          }}
        />
      ))}
    </div>
  );
};




